const html = require('choo/html');
const { list } = require('../utils');
const archiveTile = require('./archiveTile');
const modal = require('./modal');
const intro = require('./intro');

module.exports = function(state, emit) {
  const archives = state.storage.files
    .filter(archive => !archive.expired)
    .map(archive => archiveTile(state, emit, archive));
  let left = '';
  if (state.uploading) {
    left = archiveTile.uploading(state, emit);
  } else if (state.archive.numFiles > 0) {
    left = archiveTile.wip(state, emit);
  } else {
    left = archiveTile.empty(state, emit);
  }
  archives.reverse();
  const right =
    archives.length === 0
      ? intro(state, emit)
      : list(archives, 'h-full overflow-y-auto w-full py-0 pr-1 pl-0', 'mb-3 w-full');

  return html`
    <main class="main">
      <section
        class="relative h-full w-full p-4 md:p-5 overflow-hidden md:flex md:flex-row md:rounded-xl md:shadow-big bg-white"
        style="border: 1px solid #dc2626; box-shadow: 0 10px 25px -4px rgba(220, 38, 38, 0.12), 0 4px 10px -2px rgba(0, 0, 0, 0.04);"
      >
        ${state.modal && modal(state, emit)}
        <div class="w-full md:w-1/2 md:pr-2 flex flex-col h-full">${left}</div>
        <div class="mt-4 md:mt-0 w-full md:w-1/2 md:pl-2 flex flex-col h-full">${right}</div>
      </section>
    </main>
  `;
};
